import { createTheme } from "@mui/material/styles";

// Mirrors the design tokens from MTS-Bookings.Frontend so Collections feels native to MTS,
// without affecting the rest of the dashboard (Shipments/Transfers stay on their original theme).
// To pull these tokens into other pages later, lift this file to a shared location and re-use.

export const collectionsTokens = {
  color: {
    primary: "#c8102e",       // MTS red
    secondary: "#f5a623",     // MTS orange (success/confirm)
    text: "#1a1a1a",
    textMuted: "#666",
    textLight: "#888",
    textSubtle: "#999",
    bgPage: "#f8f9fa",
    bgCard: "#ffffff",
    border: "#e0e0e0",
    borderSoft: "#e8e8e8",
    disabled: "#f5f5f5",
    error: "#c0392b",
    badgeBg: "#fef3cd",       // pale yellow for status pills
    success: "#1b7a3e",
    successBg: "#f0faf0",
    company: {
      MTS: "#1a1a1a",
      TAB: "#1b7a3e",
      MTSC: "#c8102e",        // share brand red
    },
  },
  radius: {
    sm: 8,
    md: 10,
    lg: 12,
    pill: 999,
  },
  font: {
    family: "-apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif",
    weight: { body: 400, medium: 500, semibold: 600, bold: 700 },
    size: { h1: 28, h2: 20, body: 16, input: 15, label: 13, helper: 12 },
  },
  shadow: {
    hover: "0 4px 12px rgba(0,0,0,0.08)",
  },
};

export const collectionsTheme = createTheme({
  palette: {
    primary: { main: collectionsTokens.color.primary, contrastText: "#fff" } as any,
    secondary: { main: collectionsTokens.color.secondary, contrastText: "#fff" } as any,
    background: {
      default: collectionsTokens.color.bgPage,
      paper: collectionsTokens.color.bgCard,
    },
    text: {
      primary: collectionsTokens.color.text,
      secondary: collectionsTokens.color.textMuted,
    },
    divider: collectionsTokens.color.border,
    error: { main: collectionsTokens.color.error } as any,
    success: { main: collectionsTokens.color.success } as any,
  },
  typography: {
    fontFamily: collectionsTokens.font.family,
    h1: { fontSize: collectionsTokens.font.size.h1, fontWeight: collectionsTokens.font.weight.bold, color: collectionsTokens.color.text },
    h2: { fontSize: collectionsTokens.font.size.h2, fontWeight: collectionsTokens.font.weight.semibold, color: collectionsTokens.color.text },
    body1: { fontSize: collectionsTokens.font.size.body, color: collectionsTokens.color.text },
    body2: { fontSize: collectionsTokens.font.size.input, color: collectionsTokens.color.textMuted },
    button: { textTransform: "none", fontWeight: collectionsTokens.font.weight.semibold },
  },
  shape: { borderRadius: collectionsTokens.radius.sm },
  components: {
    MuiCard: {
      styleOverrides: {
        root: {
          borderRadius: collectionsTokens.radius.lg,
          border: `2px solid ${collectionsTokens.color.border}`,
          boxShadow: "none",
          transition: "box-shadow 0.2s ease, transform 0.2s ease",
          "&:hover": { boxShadow: collectionsTokens.shadow.hover },
        },
      },
    },
    MuiButton: {
      styleOverrides: {
        root: {
          borderRadius: collectionsTokens.radius.sm,
          fontWeight: collectionsTokens.font.weight.semibold,
          boxShadow: "none",
          "&:hover": { boxShadow: "none" },
        },
        containedPrimary: {
          backgroundColor: collectionsTokens.color.primary,
          "&:hover": { backgroundColor: "#a50d24" },
        },
        containedSecondary: {
          backgroundColor: collectionsTokens.color.secondary,
          "&:hover": { backgroundColor: "#d8911e" },
        },
      },
    },
    MuiChip: {
      styleOverrides: {
        root: {
          borderRadius: collectionsTokens.radius.lg,
          fontWeight: collectionsTokens.font.weight.semibold,
        },
      },
    },
    MuiTextField: {
      defaultProps: { variant: "outlined" },
    },
  },
});
